import React from 'react'
import { Box, Typography } from '@mui/material'
import { panelTitleSx } from './pushStyles'

interface Props {
    title?: string
    icon?: React.ReactNode
    action?: React.ReactNode
    children: React.ReactNode
    sx?: object
    bodySx?: object
}

const PushPanel: React.FC<Props> = ({ title, icon, action, children, sx, bodySx }) => (
    <Box className="bg-dark-color border-10 p-0" sx={{ overflow: 'hidden', ...sx }}>
        {title && (
            <Box sx={{ p: '14px 20px', borderBottom: '1px solid #1e1e1e', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1.5 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {icon}
                    <Typography sx={panelTitleSx}>{title}</Typography>
                </Box>
                {action}
            </Box>
        )}
        <Box sx={{ p: '16px 20px', ...bodySx }}>{children}</Box>
    </Box>
)

export default PushPanel
